// extracted by mini-css-extract-plugin
export var icon = "index-module--icon--+gxoM";
export var flex = "index-module--flex--3xpmM";
export var text = "index-module--text--coAaK";
export var flex_fractie = "index-module--flex_fractie--0Ov2W";
export var success_fractie = "index-module--success_fractie--bxijM";